import { Form, Button } from 'antd';
import IcSend from 'assets/Icons/IcSend';
import ModalSMS, { IModalSMSFuncFinish, useModalSMSRef } from 'components/ModalSMS';
import { FEATURE_KEYS } from 'constants/Permission';
import paymentApis from 'features/payment/services/apis';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import styled from 'styled-components';
import toast from 'utils/toast';
import PermissionManager from 'widgets/PermissionVerify';

type Props = {
  billId?: string;
  defaultSMSPhone?: string;
  small?: boolean;
  v2?: boolean;
  hook?: boolean;
  permission?: FEATURE_KEYS;
};
type Ref = {
  open: () => void;
};
export const useButtonTicketSendSMSRef = () => useRef<Ref>(null);
const ButtonTicketSendSMS = forwardRef<Ref, Props>(({ hook, v2, billId, defaultSMSPhone, small, permission }, ref) => {
  const setLoadingPage = useSetLoadingPage();
  const [smsForm] = Form.useForm();
  const smsRef = useModalSMSRef();
  const onFormSMSFinish: IModalSMSFuncFinish = async (values) => {
    if (!billId) return;
    smsRef.current?.close();
    setLoadingPage(true);
    try {
      const res = await paymentApis.sendSMSEmailReceipt(billId, 'SMS', values.phone?.replace(/[^0-9]/g, ''));
      if (res.data.data) {
        toast.success(res.data?.message || 'Success');
      }
    } catch (error) { }
    finally {
      setLoadingPage(false);
    }
  };

  const onOpen = async () => {
    if (permission) {
      const result = await PermissionManager.verify(permission);
      if (!result || result?.skip) return smsRef.current?.open(defaultSMSPhone || '');
      if (!result.verifyData) return;
      smsRef.current?.open(defaultSMSPhone || '');
      return;
    }
    smsRef.current?.open(defaultSMSPhone || '');
  };

  useImperativeHandle(ref, () => ({
    open: onOpen,
  }));

  return (
    <>
      {!hook && <SmsButton onClick={onOpen} icon={<IcSend width={20} height={20} fill='#FFF'/>}>SMS</SmsButton>}
      <ModalSMS v2={v2} ref={smsRef} form={smsForm} onFinish={onFormSMSFinish} />
    </>
  );
});
ButtonTicketSendSMS.displayName = 'ButtonTicketSendSMS';
export default ButtonTicketSendSMS;

export const SmsButton = styled(Button)`
  height: 42px;
  padding: 0 12px;
  border-radius: 8px;
  background: linear-gradient(135deg, #fb923c, #f97316);
  border: none;
  color: white;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(249, 115, 22, 0.3);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  font-family: 'Poppins';

  &:hover {
    background: linear-gradient(135deg, #f97316, #ea580c) !important;
    color: white !important;
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(249, 115, 22, 0.45);
  }

  &:active {
    transform: scale(0.98);
  }
`;